<template>
  <v-container>
    <v-row>
      <v-col>&nbsp;</v-col>
    </v-row>
    <v-row>
        <v-col></v-col>
        <v-col></v-col>
        <v-col>
          <v-card 
            dark
            max-width="400"
            raised>
           
            <v-card-title color="white">Web Fax Services</v-card-title>
            <v-list three-line>
                <v-subheader>You can depend on</v-subheader>

                <v-divider
                  
                ></v-divider>

                <v-list-item>
                  <v-list-item-avatar>
                    <v-icon>mdi-check-bold</v-icon>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title>Multiple user accounts</v-list-item-title>
                    <v-list-item-subtitle >Create multiple user accounts for each of your staff.</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-avatar>
                    <v-icon>mdi-check-bold</v-icon>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title>Multiple fax lines</v-list-item-title>
                    <v-list-item-subtitle >Mutlple fax lines with user permissions. Restrict access to private fax lines.</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-avatar>
                    <v-icon>mdi-check-bold</v-icon>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title>Web Portal and Fax-To-Email</v-list-item-title>
                    <v-list-item-subtitle>Send and recieve through the web portal and receive PDF emails of your incoming faxes.</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-avatar>
                    <v-icon>mdi-check-bold</v-icon>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title>PDF Drop (Coming soon)</v-list-item-title>
                    <v-list-item-subtitle>Accept PDFs to your fax line over the internet. People don't need a fax machine to send you documents.</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                
            </v-list>
            <v-card-actions >
              <v-spacer></v-spacer>
            <v-btn
              color="success"
              @click="gotoPlans"
            >View Plans
            </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'HelloWorld',

    data: () => ({
      
    }),
    methods: {
      gotoPlans: function() {
        this.$router.push('/pricing');
      },
    }
  }
</script>
